<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
    </div>
  </div>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <!-- Eliminamos la tarjeta (card) que encapsula el formulario -->
              <div class="mt-8 login-container">
                <div class="pb-0 text-center">
                  <!-- Logo con animación sutil -->
                  <img 
                    :src="logo" 
                    class="mx-auto d-block logo-animate" 
                    alt="logo" 
                    style="max-width: 200px;"
                  />
                  <h3 class="font-weight-bolder text-success text-gradient text-center mt-3 welcome-text">
                    Bienvenido
                  </h3>
                </div>
                <div class="form-container">
                  <!-- Primer paso: solo email -->
                  <Form
                    v-if="!emailSubmitted"
                    role="form"
                    class="login-form"
                    :validation-schema="emailSchema"
                    @submit="handleEmailSubmit"
                  >
                    <div class="login-field-group">
                      <label for="email" class="login-label">Email</label>
                      <soft-field
                        id="email"
                        v-model="user.email"
                        type="email"
                        placeholder="Introduce tu correo"
                        name="email"
                        class="login-input"
                      />
                    </div>

                    <!-- Switch Recordarme simplificado -->
                    <div class="login-remember-container">
                      <soft-switch 
                        id="rememberMe" 
                        name="rememberMe" 
                        v-model="rememberMe"
                      >
                        <span class="ms-2 login-remember-text">Recordarme</span>
                      </soft-switch>
                    </div>

                    <div class="login-button-container">
                      <soft-button
                        class="login-submit-button"
                        variant="gradient"
                        color="success"
                        full-width
                        :is-disabled="loading || !user.email"
                      >
                        <span v-if="loading" class="loading-spinner">
                          <div class="glass-spinner"></div>
                          <span class="loading-text">Verificando...</span>
                        </span>
                        <span v-else class="button-content">
                          <i class="fas fa-arrow-right button-icon"></i>
                          <span>Continuar</span>
                        </span>
                      </soft-button>
                    </div>
                  </Form>

                  <!-- Segundo paso: solo código de acceso -->
                  <Form
                    v-if="emailSubmitted"
                    role="form"
                    class="login-form"
                    :validation-schema="passwordSchema"
                    @submit="handleLogin"
                  >
                    <!-- Botón volver -->
                    <div class="back-button-container">
                      <button 
                        type="button" 
                        class="back-button"
                        @click="resetForm"
                      >
                        <i class="fas fa-arrow-left"></i>
                        <span>Volver</span>
                      </button>
                    </div>

                    <div class="login-field-group">
                      <div class="text-center mb-3">
                        <div class="login-code-message">
                          <div class="message-icon">
                            <i class="fas fa-envelope"></i>
                          </div>
                          <div class="message-content">
                            <h5 class="message-title">Código enviado</h5>
                            <p class="message-text">Enviamos un código de acceso temporal a<br><strong>{{ maskEmail(user.email) }}</strong></p>
                          </div>
                        </div>
                      </div>
                      <div class="password-field-container">
                        <soft-field
                          id="password"
                          v-model="user.password"
                          type="text"
                          placeholder="000000"
                          name="password"
                          class="login-input code-input"
                        />
                      </div>
                    </div>

                    <!-- ELIMINAMOS EL REMEMBER CONTAINER DEL SEGUNDO FORMULARIO -->

                    <div class="login-button-container">
                      <soft-button
                        class="login-submit-button"
                        variant="gradient"
                        color="success"
                        full-width
                        :is-disabled="loading || !user.password"
                      >
                        <span v-if="loading" class="loading-spinner">
                          <div class="glass-spinner"></div>
                          <span class="loading-text">Iniciando sesión...</span>
                        </span>
                        <span v-else class="button-content">
                          <i class="fas fa-sign-in-alt button-icon"></i>
                          <span>Iniciar Sesión</span>
                        </span>
                      </soft-button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8">
                <div
                  class="bg-cover oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6"
                  :style="{
                    backgroundImage:
                      'url(' + require('@/assets/img/curved-images/curved9.jpg') + ')',
                  }"
                >
                  <div class="overlay-gradient"></div>
                  <div class="welcome-message">
                    <h2 class="text-white">Bienvenido a nuestra plataforma</h2>
                    <p class="text-white-50">Accede para gestionar tus proyectos de forma eficiente</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer />
</template>

<script>
import AppFooter from "@/examples/PageLayout/Footer.vue";
import SoftField from "@/components/SoftField.vue";
import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftButton from "@/components/SoftButton.vue";
import showSwal from "/src/mixins/showSwal.js";
import { mapMutations } from "vuex";
import { Form } from "vee-validate";
import * as yup from "yup";
import axios from "axios"; // Asegúrate de que axios esté instalado

// Importa el logo
import logo from "@/assets/img/logo-4c.png";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Login",
  components: {
    AppFooter,
    SoftField,
    SoftSwitch,
    SoftButton,
    Form,
  },

  data() {
    const emailSchema = yup.object().shape({
      email: yup
        .string()
        .required("Email obligatorio")
        .email("Ingrese un email válido (ej.: nombre@empresa.com)"),
    });
    
    const passwordSchema = yup.object().shape({
      password: yup.string().required("Código de acceso obligatorio"),
    });
    
    const schema = yup.object().shape({
      email: yup
        .string()
        .required("Email obligatorio")
        .email("Ingrese un email válido (ej.: nombre@empresa.com)"),
      password: yup.string().required("Código de acceso obligatorio"),
    });
    
    const user = {
      email: "",
      password: "",
    };
    
    return {
      loading: false,
      user,
      schema,
      emailSchema,
      passwordSchema,
      logo,
      formSubmitted: false,
      emailSubmitted: false,
      rememberMe: true,
    };
  },
  created() {
    this.toggleEveryDisplay();
    // Asegurar que el botón de configuración esté oculto
    this.$store.state.hideConfigButton = true;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    // Restaurar el botón de configuración al salir
    this.$store.state.hideConfigButton = false;
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    maskEmail(email) {
      if (!email) return '';
      const parts = email.split('@');
      if (parts.length !== 2) return email;
      
      const name = parts[0];
      const domain = parts[1];
      
      // Si el nombre tiene menos de 3 caracteres, mostramos solo el primer carácter
      // Si tiene 3 o más, mostramos los primeros 3 caracteres
      const maskedName = name.length <= 3 
        ? name.substring(0, 1) + '***' 
        : name.substring(0, 3) + '***';
        
      return maskedName + '@' + domain;
    },

    // Ya no necesitamos el método togglePassword
    
    
    async handleEmailSubmit() {
      this.loading = true;
      
      try {
        // Hacemos una petición al backend para verificar si el email existe
        const response = await axios.post('/api/v2/check-email', {
          email: this.user.email
        });
        
        if (response.data.exists) {
          // Si el email existe, avanzamos al siguiente paso
          this.emailSubmitted = true;
          
          // Aquí podrías también disparar una acción para enviar el código de acceso
          // Por ejemplo:
          // await axios.post('/api/send-access-code', { email: this.user.email });
        } else {
          // Si el email no existe, mostramos un mensaje de error
          showSwal.methods.showSwal({
            type: "error",
            message: "El correo electrónico no está registrado en el sistema.",
          });
        }
      } catch (error) {
        console.error('Error al verificar el email:', error);
        showSwal.methods.showSwal({
          type: "error",
          message: "Ha ocurrido un error al verificar el correo. Por favor, inténtalo de nuevo.",
        });
      } finally {
        this.loading = false;
      }
    },
    
    resetForm() {
      this.emailSubmitted = false;
      this.user.password = "";
    },

    async handleLogin() {
      this.formSubmitted = true;
      this.loading = true;
      try {
        await this.$store.dispatch("auth/login", this.user);
        this.$router.push("/welcome");
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Credenciales inválidas. Por favor, inténtalo de nuevo.",
        });
        this.loading = false;
        this.formSubmitted = false;
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  width: 100%;
  padding: 2.5rem 2rem;
  background: transparent;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

[data-bs-theme="dark"] .login-container,
.dark-mode .login-container {
  background: transparent !important;
}

.form-container {
  margin-top: 2rem;
  text-align: left;
  position: relative;
  z-index: 1;
}

.login-form {
  width: 100%;
  display: block;
}

.login-field-group {
  margin-bottom: 2rem;
  position: relative;
  display: block;
  width: 100%;
}

.login-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #344767;
  margin-bottom: 0.75rem;
  display: block;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-size: 0.8rem;
}

[data-bs-theme="dark"] .login-label,
.dark-mode .login-label {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* Hacer el contenedor del input completamente transparente */
.login-input.form-group {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  margin-bottom: 0;
  padding: 0;
}

/* Aplicar glassmorphism solo al input real - UNIFICADO */
.login-input .form-control {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(12px);
  padding: 14px 18px !important;
  font-size: 0.95rem;
  font-weight: 500;
  color: #344767;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.login-input .form-control::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  pointer-events: none;
  z-index: -1;
}

/* Estilos específicos para el input del código - CON ID */
#password {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace !important;
}

#password .form-control,
#password input,
#password input[type="text"] {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  padding: 20px 24px !important;
  font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace !important;
  min-height: 65px !important;
  line-height: 1.2 !important;
}

.login-input.code-input .form-control,
.code-input.login-input .form-control,
.code-input .form-control {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  padding: 20px 24px !important;
  font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace !important;
  min-height: 65px !important;
  line-height: 1.2 !important;
}

#password::placeholder,
#password .form-control::placeholder,
#password input::placeholder {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  opacity: 0.5 !important;
  font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace !important;
}

.login-input.code-input .form-control::placeholder,
.code-input.login-input .form-control::placeholder,
.code-input .form-control::placeholder {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  opacity: 0.4 !important;
  font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace !important;
}

.login-input.code-input .form-control:focus,
.code-input.login-input .form-control:focus,
.code-input .form-control:focus {
  border-color: rgba(92, 184, 92, 0.8) !important;
  background: rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 0 0 4px rgba(92, 184, 92, 0.2), 0 6px 20px rgba(92, 184, 92, 0.15) !important;
  transform: translateY(-2px) !important;
  outline: none !important;
  text-align: center !important;
}

/* Modo oscuro para input del código */
[data-bs-theme="dark"] .login-input.code-input .form-control,
[data-bs-theme="dark"] .code-input.login-input .form-control,
[data-bs-theme="dark"] .code-input .form-control,
.dark-mode .login-input.code-input .form-control,
.dark-mode .code-input.login-input .form-control,
.dark-mode .code-input .form-control {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: rgba(255, 255, 255, 0.98) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.1) !important;
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
}

[data-bs-theme="dark"] .login-input.code-input .form-control::placeholder,
[data-bs-theme="dark"] .code-input.login-input .form-control::placeholder,
[data-bs-theme="dark"] .code-input .form-control::placeholder,
.dark-mode .login-input.code-input .form-control::placeholder,
.dark-mode .code-input.login-input .form-control::placeholder,
.dark-mode .code-input .form-control::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
  text-align: center !important;
  font-size: 1.8rem !important;
  letter-spacing: 0.4rem !important;
}

[data-bs-theme="dark"] .login-input.code-input .form-control:focus,
[data-bs-theme="dark"] .code-input.login-input .form-control:focus,
[data-bs-theme="dark"] .code-input .form-control:focus,
.dark-mode .login-input.code-input .form-control:focus,
.dark-mode .code-input.login-input .form-control:focus,
.dark-mode .code-input .form-control:focus {
  border-color: rgba(108, 204, 108, 0.8) !important;
  background: rgba(255, 255, 255, 0.15) !important;
  box-shadow: 0 0 0 4px rgba(108, 204, 108, 0.25), 0 6px 20px rgba(108, 204, 108, 0.2), inset 0 2px 4px rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-2px) !important;
  color: white !important;
  text-align: center !important;
}

.login-input .form-control:focus {
  border-color: rgba(92, 184, 92, 0.6) !important;
  background: rgba(255, 255, 255, 0.15) !important;
  box-shadow: 0 0 0 3px rgba(92, 184, 92, 0.15), 0 4px 12px rgba(92, 184, 92, 0.1) !important;
  transform: translateY(-1px);
  outline: none !important;
}

/* Modo oscuro para el contenedor */
[data-bs-theme="dark"] .login-input.form-group,
.dark-mode .login-input.form-group {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

/* Modo oscuro para el input */
[data-bs-theme="dark"] .login-input .form-control,
.dark-mode .login-input .form-control {
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.95) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 2px rgba(255, 255, 255, 0.1) !important;
}

[data-bs-theme="dark"] .login-input .form-control::placeholder,
.dark-mode .login-input .form-control::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

[data-bs-theme="dark"] .login-input .form-control:focus,
.dark-mode .login-input .form-control:focus {
  border-color: rgba(108, 204, 108, 0.7) !important;
  background: rgba(255, 255, 255, 0.12) !important;
  box-shadow: 0 0 0 3px rgba(108, 204, 108, 0.2), 0 4px 12px rgba(108, 204, 108, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-1px) !important;
  color: white !important;
}


.password-field-container {
  position: relative;
  width: 100%;
}

.password-input {
  padding-right: 40px; /* Espacio para el icono */
}

.login-password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
  z-index: 2;
}

.login-password-toggle:hover {
  color: #5cb85c;
}

/* Container del switch recordarme simplificado */
.login-remember-container {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  padding: 0.5rem 0;
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.6s both;
}

.login-remember-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: #344767;
  letter-spacing: 0.2px;
}

[data-bs-theme="dark"] .login-remember-text,
.dark-mode .login-remember-text {
  color: rgba(255, 255, 255, 0.9) !important;
}

.login-button-container {
  text-align: center;
  margin-top: 1.5rem;
}

.login-submit-button {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 14px;
  font-weight: 600;
  padding: 16px 32px;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 6px 20px rgba(92, 184, 92, 0.2);
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  min-height: 52px;
}

/* Estilos para botones en modo oscuro */
[data-bs-theme="dark"] .login-submit-button,
.dark-mode .login-submit-button {
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  box-shadow: 0 4px 16px rgba(108, 204, 108, 0.3), 0 2px 8px rgba(0, 0, 0, 0.3) !important;
  backdrop-filter: blur(15px) !important;
}

[data-bs-theme="dark"] .login-submit-button span,
.dark-mode .login-submit-button span {
  color: white !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
}

/* Botón volver glassmorphism */
.back-button-container {
  margin-bottom: 1.5rem;
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.3s both;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.back-button:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #5cb85c;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.back-button i {
  font-size: 0.75rem;
  transition: transform 0.3s ease;
}

.back-button:hover i {
  transform: translateX(-2px);
}

/* Modo oscuro para botón volver */
[data-bs-theme="dark"] .back-button,
.dark-mode .back-button {
  background: rgba(255, 255, 255, 0.04) !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
  color: rgba(255, 255, 255, 0.7) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

[data-bs-theme="dark"] .back-button:hover,
.dark-mode .back-button:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
  color: #6cc46c !important;
}

/* Loading spinner glassmorphism */
.loading-spinner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.glass-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* Botón con icono mejorado */
.button-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.button-icon {
  font-size: 0.875rem;
  transition: transform 0.3s ease;
}

.login-submit-button:hover .button-icon {
  transform: translateX(2px);
}

.login-submit-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s;
}

.login-submit-button:hover::before {
  left: 100%;
}

.login-submit-button span {
  font-weight: bold;
  text-align: center;
}

.login-submit-button:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 8px 25px rgba(92, 184, 92, 0.3), 0 4px 16px rgba(92, 184, 92, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

[data-bs-theme="dark"] .login-submit-button:hover,
.dark-mode .login-submit-button:hover {
  transform: translateY(-3px) scale(1.02) !important;
  box-shadow: 0 8px 25px rgba(108, 204, 108, 0.4), 0 4px 16px rgba(108, 204, 108, 0.3), 0 2px 8px rgba(0, 0, 0, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.login-submit-button:active {
  transform: translateY(-1px) scale(1.01);
  transition: all 0.1s ease;
}

.welcome-text {
  font-size: 2rem;
  margin-bottom: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #5cb85c, #4a9f4a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-bs-theme="dark"] .welcome-text,
.dark-mode .welcome-text {
  background: linear-gradient(135deg, #7ee17e, #6cc46c) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  text-shadow: 0 2px 8px rgba(126, 225, 126, 0.3) !important;
}

.logo-animate {
  animation: fadeInDown 1.2s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

/* Email display en el segundo paso */
/* Eliminamos los estilos relacionados con la visualización del email */

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
  50% {
    opacity: 0.7;
    transform: translateY(-5px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Animación para el contenedor principal */
@keyframes slideInGlass {
  0% {
    opacity: 0;
    transform: translateY(40px) scale(0.9);
    backdrop-filter: blur(0px);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    backdrop-filter: blur(20px);
  }
}

.login-container {
  animation: slideInGlass 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.3s both;
}

/* Animación para los campos de entrada */
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-field-group {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.5s both;
}

.login-field-group:nth-child(2) {
  animation-delay: 0.7s;
}

.login-button-container {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.9s both;
}

/* Mejoras para la imagen lateral */
.oblique-image {
  position: relative;
  border-radius: 0 10px 10px 0;
  overflow: hidden;
}

/* Mejoras para la imagen lateral en modo oscuro */
[data-bs-theme="dark"] .overlay-gradient,
.dark-mode .overlay-gradient {
  background: linear-gradient(135deg, rgba(108, 204, 108, 0.1), rgba(0, 0, 0, 0.2)) !important;
}

[data-bs-theme="dark"] .welcome-message h2,
.dark-mode .welcome-message h2 {
  color: rgba(255, 255, 255, 0.95) !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5) !important;
}

[data-bs-theme="dark"] .welcome-message p,
.dark-mode .welcome-message p {
  color: rgba(255, 255, 255, 0.8) !important;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.4) !important;
}

.overlay-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(50, 193, 75, 0.4), rgba(0, 0, 0, 0.3));
  z-index: 1;
}

.welcome-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
  width: 80%;
  animation: fadeIn 1.5s ease-out;
}

/* Mensaje de código mejorado con glassmorphism */
.login-code-message {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.5rem;
  background: rgba(92, 184, 92, 0.08);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(92, 184, 92, 0.2);
  border-radius: 14px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 16px rgba(92, 184, 92, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideInFromTop 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.message-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(92, 184, 92, 0.15);
  border-radius: 50%;
  color: #5cb85c;
  font-size: 1.1rem;
}

.message-content {
  flex: 1;
}

.message-title {
  font-size: 1rem;
  font-weight: 600;
  color: #344767;
  margin: 0 0 0.5rem 0;
  letter-spacing: 0.3px;
}

.message-text {
  font-size: 0.875rem;
  color: #5a6c7d;
  margin: 0;
  line-height: 1.5;
}

.message-text strong {
  color: #344767;
  font-weight: 600;
}

/* Modo oscuro para mensaje de código - MEJORADO */
[data-bs-theme="dark"] .login-code-message,
.dark-mode .login-code-message {
  background: rgba(108, 204, 108, 0.15) !important;
  border-color: rgba(108, 204, 108, 0.3) !important;
  box-shadow: 0 4px 16px rgba(108, 204, 108, 0.2), 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

[data-bs-theme="dark"] .login-code-message .message-icon,
.dark-mode .login-code-message .message-icon {
  background: rgba(108, 204, 108, 0.25) !important;
  color: #7ee17e !important;
  box-shadow: 0 2px 8px rgba(108, 204, 108, 0.3) !important;
}

[data-bs-theme="dark"] .login-code-message .message-title,
.dark-mode .login-code-message .message-title {
  color: rgba(255, 255, 255, 0.98) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
}

[data-bs-theme="dark"] .login-code-message .message-text,
.dark-mode .login-code-message .message-text {
  color: rgba(255, 255, 255, 0.95) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
}

[data-bs-theme="dark"] .login-code-message .message-text strong,
.dark-mode .login-code-message .message-text strong {
  color: #ffffff !important;
  font-weight: 700 !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5) !important;
  opacity: 1 !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInFromTop {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes breathe {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

/* Hover effects adicionales */
.login-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

[data-bs-theme="dark"] .login-container:hover,
.dark-mode .login-container:hover {
  background: transparent !important;
}

/* Efectos de pulse para elementos interactivos */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(92, 184, 92, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(92, 184, 92, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(92, 184, 92, 0);
  }
}

.login-submit-button:focus {
  animation: pulse 1.5s infinite;
}

[data-bs-theme="dark"] .login-submit-button:focus,
.dark-mode .login-submit-button:focus {
  animation: pulseDark 1.5s infinite !important;
}

@keyframes pulseDark {
  0% {
    box-shadow: 0 0 0 0 rgba(108, 204, 108, 0.5);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(108, 204, 108, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(108, 204, 108, 0);
  }
}

/* Micro-interacciones y efectos hover refinados */
.login-field-group:hover .login-label {
  color: #5cb85c;
  transform: translateY(-1px);
}

[data-bs-theme="dark"] .login-field-group:hover .login-label,
.dark-mode .login-field-group:hover .login-label {
  color: #6cc46c !important;
}

.login-input .form-control:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 255, 255, 0.4);
}

[data-bs-theme="dark"] .login-input .form-control:hover,
.dark-mode .login-input .form-control:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* Animación breathing sutil para elementos glassmorphism */
.login-code-message {
  animation: slideInFromTop 0.6s cubic-bezier(0.4, 0, 0.2, 1), breathe 4s ease-in-out infinite 2s;
}


/* Estados de validación en tiempo real */
.login-input .form-control.valid {
  border-color: rgba(92, 184, 92, 0.6) !important;
  background: rgba(92, 184, 92, 0.05) !important;
  box-shadow: 0 0 0 3px rgba(92, 184, 92, 0.1), 0 4px 12px rgba(92, 184, 92, 0.1) !important;
}

.login-input .form-control.invalid {
  border-color: rgba(220, 53, 69, 0.6) !important;
  background: rgba(220, 53, 69, 0.05) !important;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1), 0 4px 12px rgba(220, 53, 69, 0.1) !important;
}

[data-bs-theme="dark"] .login-input .form-control.valid,
.dark-mode .login-input .form-control.valid {
  border-color: rgba(108, 204, 108, 0.6) !important;
  background: rgba(108, 204, 108, 0.08) !important;
}

[data-bs-theme="dark"] .login-input .form-control.invalid,
.dark-mode .login-input .form-control.invalid {
  border-color: rgba(248, 81, 106, 0.6) !important;
  background: rgba(248, 81, 106, 0.08) !important;
}

/* Responsive adjustments MEJORADO */
@media (max-width: 767.98px) {
  .welcome-text {
    font-size: 1.6rem;
  }
  
  .login-container {
    margin-top: 2rem;
    padding: 2rem 1.5rem;
  }
  
  
  .login-input .form-control {
    padding: 12px 16px !important;
    font-size: 0.9rem;
  }
  
  .login-input.code-input .form-control,
  .code-input.login-input .form-control,
  .code-input .form-control {
    font-size: 1.4rem !important;
    letter-spacing: 0.3rem !important;
    padding: 16px 20px !important;
    min-height: 58px !important;
    text-align: center !important;
  }
  
  .login-input.code-input .form-control::placeholder,
  .code-input.login-input .form-control::placeholder,
  .code-input .form-control::placeholder {
    font-size: 1.4rem !important;
    letter-spacing: 0.3rem !important;
    text-align: center !important;
  }
  
  .login-submit-button {
    padding: 14px 24px;
    font-size: 0.9rem;
    min-height: 48px;
  }
  
  .login-code-message {
    padding: 1.25rem;
  }
  
  .message-icon {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
  
  .back-button {
    padding: 0.6rem 0.875rem;
    font-size: 0.8rem;
  }
}
</style>

<style>
/* Estilos GLOBALES para el input del código - SIN SCOPED */
#password .form-control,
#password input,
#password input[type="text"],
.code-input .form-control,
.code-input input,
.code-input input[type="text"] {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  padding: 20px 24px !important;
  font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace !important;
  min-height: 65px !important;
  line-height: 1.3 !important;
}

#password .form-control::placeholder,
#password input::placeholder,
.code-input .form-control::placeholder,
.code-input input::placeholder {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  opacity: 0.5 !important;
  font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace !important;
}

#password .form-control:focus,
#password input:focus,
.code-input .form-control:focus,
.code-input input:focus {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
}

/* Modo oscuro global */
[data-bs-theme="dark"] #password .form-control,
[data-bs-theme="dark"] #password input,
[data-bs-theme="dark"] .code-input .form-control,
[data-bs-theme="dark"] .code-input input,
.dark-mode #password .form-control,
.dark-mode #password input,
.dark-mode .code-input .form-control,
.dark-mode .code-input input {
  text-align: center !important;
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.4rem !important;
  color: rgba(255, 255, 255, 0.98) !important;
}

[data-bs-theme="dark"] #password .form-control::placeholder,
[data-bs-theme="dark"] #password input::placeholder,
[data-bs-theme="dark"] .code-input .form-control::placeholder,
[data-bs-theme="dark"] .code-input input::placeholder,
.dark-mode #password .form-control::placeholder,
.dark-mode #password input::placeholder,
.dark-mode .code-input .form-control::placeholder,
.dark-mode .code-input input::placeholder {
  text-align: center !important;
  color: rgba(255, 255, 255, 0.5) !important;
  font-size: 1.8rem !important;
  letter-spacing: 0.4rem !important;
}
</style>